import { render } from "./extremeChart.vue?vue&type=template&id=ffa2616c"
import script from "./extremeChart.vue?vue&type=script&lang=js"
export * from "./extremeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__